import {
  submitForm,
  submitBackupLog,
  sendErrorNotification,
  trackGoogleAnalytics,
  trackFacebookPixel,
  trackKarrotPixel,
  initKarrotPixel
} from "../utils/api";
import { formatPhoneNumber, getCurrentDateTime } from "../utils/formatting";
import { showDuplicateModal } from "../utils/duplicateModal";

export const handleFormSubmit = async ({
  name,
  phoneNumber,
  selectedOption,
  isAgreed,
  submitCount,
  setSubmitCount,
  validateInput,
  urlCode,
  urlCodeSettingId,
  navigate,
  setIsSubmitting,
  apiUrl,
  selectedValue,
  craftTag,
  redirectUrl,
  kakaotalk,
  carrotTag,
}) => {
  const MIN_DISPLAY_MS = 300;
  const startTime = Date.now();
  setIsSubmitting(true);

  // 동의 확인
  if (!isAgreed) {
    const confirmed = window.confirm(' 확인을 누르시면 개인정보처리방침에 동의하여 상담 신청이 완료됩니다.');
    if (!confirmed) {
      setIsSubmitting(false);
      return;
    }
  }

  // 입력 유효성 검사
  if (!validateInput()) {
    setIsSubmitting(false); // 유효성 실패 시 버튼 재활성화

    return;
  }

  // 제출 횟수 확인
  if (submitCount >= 5) {
    alert("제출 횟수가 최대치에 도달했습니다.");
    setIsSubmitting(false); // 유효성 실패 시 버튼 재활성화
    return;
  }

  const formattedPhoneNumber = formatPhoneNumber(phoneNumber);
  const currentDateTime = getCurrentDateTime();

  // 요청 데이터 준비
  const formData = {
    name,
    phoneNumber: formattedPhoneNumber,
    selectedOption,
    date: currentDateTime,
    urlCode,
    urlCodeSettingId,
    kakaotalk,
    ...(selectedValue && { selectedValue }),
  };

  try {
    // API 모듈을 통한 폼 제출 (크래프트 여부 자동 처리)
    const response = await submitForm(formData, apiUrl);

    if (response.status >= 200 && response.status < 300) {
      // 성공 이벤트는 submitForm 내부에서 처리됨

      // Google 태그 전송
      if (window.gtag) {
        window.gtag('set', 'user_data', {
          phone_number: Array.from(document.querySelectorAll('[type="tel"]')).map(function(e){return e.value}).join('').replace(/^0/,'+82')
        });

        window.gtag('event', 'conversion', {send_to: 'AW-17656885998/DK5HCMy6vq4bEO7luuNB'});
      }

      const elapsed = Date.now() - startTime;
      if (elapsed < MIN_DISPLAY_MS) await new Promise(r => setTimeout(r, MIN_DISPLAY_MS - elapsed));

      if (redirectUrl) {
        window.location.href = redirectUrl;
      } else {
        navigate("/thanks", {
          state: {
            urlCode,
            craftTag,
            carrotTag,
          },
        });
      }

      setSubmitCount((prev) => prev + 1);
    } else {
      throw new Error("Unexpected server response");
    }
  } catch (error) {
    // 30일 중복 차단
    if (error.response?.status === 409) {
      const message = error.response?.data?.message || "이미 상담 접수된 번호입니다.";
      console.log(`[30일 중복 차단] ${message}`);
      showDuplicateModal(message);
      setIsSubmitting(false);
      return;
    }

    console.error("API 호출 실패:", error);

    // 백업 호출
    try {
      console.log("백업 API 호출 시도...");
      await submitBackupLog({
        name,
        phoneNumber: formattedPhoneNumber,
        date: currentDateTime,
        // 유실 알림(api-server/check-inflow-anomaly.js)이 병원을 식별할 수 있도록
        urlCode,
        urlCodeSettingId,
      });
      console.log("백업 API 성공적으로 완료");
    } catch (backupError) {
      console.error("백업 API 호출 실패:", backupError);
      alert("네트워크 오류가 발생했습니다.");
      
      // 백업도 실패 시 이메일 알림 전송
      await sendErrorNotification({
        name,
        phoneNumber: formattedPhoneNumber,
        date: currentDateTime,
        urlCode,
        errorMessage: backupError.message || "백업 API 호출 실패"
      });
    }
    
    // 백업 성공/실패와 관계없이 thanks 페이지로 이동
    const elapsed = Date.now() - startTime;
    if (elapsed < MIN_DISPLAY_MS) await new Promise(r => setTimeout(r, MIN_DISPLAY_MS - elapsed));
    navigate("/thanks", {
      state: {
        urlCode,
        craftTag,
        carrotTag,
      },
    });
  } finally {
    // 3초 후 버튼 활성화
    setTimeout(() => setIsSubmitting(false), 3000);
  }
};

// 당근 태그 전용
export const loadGoogleTags = (carrotTag) => {
  if (carrotTag) {
    initKarrotPixel();
  } else {
    console.log("Karrot Pixel not loaded (carrot is true).");
  }
};
